import React, { createContext, useContext, useReducer } from "react"
import reducer from "./reducer"
import initialState from "./initState"
import { useMediaQuery } from "react-responsive"

const GeneralContext = createContext(initialState)

export const StateProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const responsive = {
    isScreenSmall: useMediaQuery({ query: "(max-width: 550px)" }),
    isScreenMedium: useMediaQuery({ query: "(max-width: 900px)" }),
    isScreenLarge: useMediaQuery({ query: "(max-width: 1200px)" }),
    isScreenExtraLarge: useMediaQuery({ query: "(min-width: 1200px)" })
  }

  return (
    <GeneralContext.Provider value={{ ...state, dispatch, responsive }}>
      {props.children}
    </GeneralContext.Provider>
  )
}

export const useStore = () => useContext(GeneralContext)